// extracted by mini-css-extract-plugin
module.exports = {"container":"propertyPageHeader_container__2ErZW","display":"propertyPageHeader_display__eRyE9","text":"propertyPageHeader_text__O__33","favoriteButton":"propertyPageHeader_favoriteButton__2FVSk"};
    if(module.hot) {
      // 1790670306269
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  